import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useTranslation } from 'react-i18next';

interface Props {
    soldOutItemQty: number;
}

function SoldOutItemsTitle({ soldOutItemQty }:Props) {
    const { t } = useTranslation('cart');
    return (
        <Row spacing={10}>
            <Text size='lg' fontWeight='bold'>
                {t('items.soldOutItems')}
            </Text>
            <Text color={colors.gray6}>
                {t('items.total')} {soldOutItemQty.toLocaleString()}{t('items.count')}
            </Text>
        </Row>
    );
}

export default SoldOutItemsTitle;
